export default "__VITE_ASSET__UE9PMA2o__"